export function stage00Lottie($block, isadmin) {

  var $ = $ || jQuery; // added to see solve jquery issue



  console.log("stage00Lottie", $block, isadmin);

  if (isadmin == true) {
    console.log("admin == true:", isadmin);
  } else {
    console.log("admin == false:", isadmin);
  };


  var container = $block[0];

  // SliderContainerEl = container.querySelector(".slider__container");

  console.log("container", container);

  var bodymovinPath = $block.find(".lottie-item").attr("data-lottie");


  console.log("bodymovinPath", bodymovinPath);

  var animation = bodymovin.loadAnimation({
    container: document.getElementById('bm'), //reivew id
    renderer: 'svg',
    loop: true,
    autoplay: true,
    // path: 'data.json'
    path: bodymovinPath
  })

  console.log("animation", animation);


} //export function slideshow($block){